import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { useWindowEvent } from '../use-window-event/use-window-event.js';

function getScrollPosition() {
  return typeof window !== "undefined" ? {
    x: window.pageXOffset,
    y: window.pageYOffset
  } : {
    x: 0,
    y: 0
  };
}

function scrollTo(_ref) {
  var x = _ref.x,
      y = _ref.y;

  if (typeof window !== "undefined") {
    var scrollOptions = {
      behavior: "smooth"
    };

    if (typeof x === "number") {
      scrollOptions.left = x;
    }

    if (typeof y === "number") {
      scrollOptions.top = y;
    }

    window.scrollTo(scrollOptions);
  }
}

function useWindowScroll() {
  var _useState = useState(getScrollPosition()),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  useWindowEvent("scroll", function () {
    return setPosition(getScrollPosition());
  });
  useWindowEvent("resize", function () {
    return setPosition(getScrollPosition());
  });
  return [position, scrollTo];
}

export { useWindowScroll };